import utils from '@/mixins/utils'

export function filtro(cadastros, exibirVermelhos, exibirVerdes) {
  let cadastros_filtrados = cadastros

  if (exibirVermelhos === true) {
    cadastros_filtrados = cadastros_filtrados.filter((item) => {
      if (item.num_escov_dent_super == null || item.num_escov_dent_super == 0) {
        return true
      }
    })
  }

  if (exibirVerdes === true) {
    cadastros_filtrados = cadastros_filtrados.filter((item) => {
      if (item.num_escov_dent_super > 0) {
        return true
      }
    })
  }

  return cadastros_filtrados
}
